"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compTokens = void 0;
var accordion_groups_json_1 = __importDefault(require("./accordion-groups.json"));
var accordions_json_1 = __importDefault(require("./accordions.json"));
var alerts_json_1 = __importDefault(require("./alerts.json"));
var avatar_groups_json_1 = __importDefault(require("./avatar-groups.json"));
var avatars_json_1 = __importDefault(require("./avatars.json"));
var badges_json_1 = __importDefault(require("./badges.json"));
var breadcrumbs_json_1 = __importDefault(require("./breadcrumbs.json"));
var button_groups_json_1 = __importDefault(require("./button-groups.json"));
var cards_json_1 = __importDefault(require("./cards.json"));
var checkboxes_json_1 = __importDefault(require("./checkboxes.json"));
var collapses_json_1 = __importDefault(require("./collapses.json"));
var contained_buttons_json_1 = __importDefault(require("./contained-buttons.json"));
var datepicker_calendars_json_1 = __importDefault(require("./datepicker-calendars.json"));
var datepicker_dayofweeks_json_1 = __importDefault(require("./datepicker-dayofweeks.json"));
var datepicker_footers_json_1 = __importDefault(require("./datepicker-footers.json"));
var datepicker_headers_json_1 = __importDefault(require("./datepicker-headers.json"));
var datepicker_monthselections_json_1 = __importDefault(require("./datepicker-monthselections.json"));
var datepickers_json_1 = __importDefault(require("./datepickers.json"));
var dialog_contents_json_1 = __importDefault(require("./dialog-contents.json"));
var dialog_footers_json_1 = __importDefault(require("./dialog-footers.json"));
var dialog_headers_json_1 = __importDefault(require("./dialog-headers.json"));
var dialogs_json_1 = __importDefault(require("./dialogs.json"));
var dividers_json_1 = __importDefault(require("./dividers.json"));
var drawers_json_1 = __importDefault(require("./drawers.json"));
var dropzones_json_1 = __importDefault(require("./dropzones.json"));
var filled_chips_json_1 = __importDefault(require("./filled-chips.json"));
var hero_cards_json_1 = __importDefault(require("./hero-cards.json"));
var icon_buttons_json_1 = __importDefault(require("./icon-buttons.json"));
var info_panels_json_1 = __importDefault(require("./info-panels.json"));
var links_json_1 = __importDefault(require("./links.json"));
var list_items_json_1 = __importDefault(require("./list-items.json"));
var lists_json_1 = __importDefault(require("./lists.json"));
var menu_items_json_1 = __importDefault(require("./menu-items.json"));
var menus_json_1 = __importDefault(require("./menus.json"));
var multilines_json_1 = __importDefault(require("./multilines.json"));
var navbar_sidebar_item_collapsible_json_1 = __importDefault(require("./navbar-sidebar-item-collapsible.json"));
var navbar_sidebar_items_json_1 = __importDefault(require("./navbar-sidebar-items.json"));
var navbar_sidebars_json_1 = __importDefault(require("./navbar-sidebars.json"));
var navbar_topbars_json_1 = __importDefault(require("./navbar-topbars.json"));
var outlined_buttons_json_1 = __importDefault(require("./outlined-buttons.json"));
var outlined_chips_json_1 = __importDefault(require("./outlined-chips.json"));
var pagination_items_json_1 = __importDefault(require("./pagination-items.json"));
var paginations_json_1 = __importDefault(require("./paginations.json"));
var poppers_json_1 = __importDefault(require("./poppers.json"));
var progress_circulars_json_1 = __importDefault(require("./progress-circulars.json"));
var progress_linears_json_1 = __importDefault(require("./progress-linears.json"));
var radios_json_1 = __importDefault(require("./radios.json"));
var rating_stars_json_1 = __importDefault(require("./rating-stars.json"));
var ratings_json_1 = __importDefault(require("./ratings.json"));
var selects_json_1 = __importDefault(require("./selects.json"));
var slider_thumbs_json_1 = __importDefault(require("./slider-thumbs.json"));
var sliders_json_1 = __importDefault(require("./sliders.json"));
var snackbars_json_1 = __importDefault(require("./snackbars.json"));
var step_items_json_1 = __importDefault(require("./step-items.json"));
var steppers_json_1 = __importDefault(require("./steppers.json"));
var switches_json_1 = __importDefault(require("./switches.json"));
var tabs_json_1 = __importDefault(require("./tabs.json"));
var tab_items_json_1 = __importDefault(require("./tab-items.json"));
var table_cells_json_1 = __importDefault(require("./table-cells.json"));
var table_footers_json_1 = __importDefault(require("./table-footers.json"));
var table_heads_json_1 = __importDefault(require("./table-heads.json"));
var table_rows_json_1 = __importDefault(require("./table-rows.json"));
var tables_json_1 = __importDefault(require("./tables.json"));
var tags_json_1 = __importDefault(require("./tags.json"));
var text_buttons_json_1 = __importDefault(require("./text-buttons.json"));
var textfields_json_1 = __importDefault(require("./textfields.json"));
var tooltips_json_1 = __importDefault(require("./tooltips.json"));
exports.compTokens = {
    accordionGroups: accordion_groups_json_1.default,
    accordions: accordions_json_1.default,
    alerts: alerts_json_1.default,
    avarargroups: avatar_groups_json_1.default,
    avatars: avatars_json_1.default,
    badges: badges_json_1.default,
    breadcrumbs: breadcrumbs_json_1.default,
    buttonGroups: button_groups_json_1.default,
    cards: cards_json_1.default,
    checkboxes: checkboxes_json_1.default,
    collapses: collapses_json_1.default,
    containedButtons: contained_buttons_json_1.default,
    datepickerCalendars: datepicker_calendars_json_1.default,
    datepickerDayofWeeks: datepicker_dayofweeks_json_1.default,
    datepickerFooters: datepicker_footers_json_1.default,
    datepickerHeaders: datepicker_headers_json_1.default,
    datepickerMonthselections: datepicker_monthselections_json_1.default,
    datepickers: datepickers_json_1.default,
    dialogContents: dialog_contents_json_1.default,
    dialogFooters: dialog_footers_json_1.default,
    dialogHeaders: dialog_headers_json_1.default,
    dialogs: dialogs_json_1.default,
    dividers: dividers_json_1.default,
    drawer: drawers_json_1.default,
    dropzones: dropzones_json_1.default,
    filledChips: filled_chips_json_1.default,
    heroCards: hero_cards_json_1.default,
    iconButton: icon_buttons_json_1.default,
    infoPanels: info_panels_json_1.default,
    links: links_json_1.default,
    listItems: list_items_json_1.default,
    lists: lists_json_1.default,
    menuItems: menu_items_json_1.default,
    menus: menus_json_1.default,
    multilines: multilines_json_1.default,
    navbarSidebarItemCollapsible: navbar_sidebar_item_collapsible_json_1.default,
    navbarSidebarItems: navbar_sidebar_items_json_1.default,
    navbarSidebars: navbar_sidebars_json_1.default,
    navbarTopbars: navbar_topbars_json_1.default,
    outlinedButtons: outlined_buttons_json_1.default,
    outlinedChips: outlined_chips_json_1.default,
    paginationItems: pagination_items_json_1.default,
    paginations: paginations_json_1.default,
    poppers: poppers_json_1.default,
    progressCirculars: progress_circulars_json_1.default,
    progressLinears: progress_linears_json_1.default,
    radios: radios_json_1.default,
    ratingStars: rating_stars_json_1.default,
    ratings: ratings_json_1.default,
    selects: selects_json_1.default,
    sliderThumbs: slider_thumbs_json_1.default,
    sliders: sliders_json_1.default,
    snackbars: snackbars_json_1.default,
    stepItems: step_items_json_1.default,
    steppers: steppers_json_1.default,
    switches: switches_json_1.default,
    tabs: tabs_json_1.default,
    tabItems: tab_items_json_1.default,
    tableCells: table_cells_json_1.default,
    tableFooters: table_footers_json_1.default,
    tableHeads: table_heads_json_1.default,
    tableRows: table_rows_json_1.default,
    tables: tables_json_1.default,
    tags: tags_json_1.default,
    textButtons: text_buttons_json_1.default,
    textFields: textfields_json_1.default,
    tooltips: tooltips_json_1.default,
};
